<div [ngStyle]="{'margin-top': '32px'}" ngStyle.lt-md="{'margin-top': '52px'}">
  <p style="margin-bottom: 3px; font-size: 16px; font-weight: 500;">Inspection Information</p>
  <mat-divider [ngStyle]="{'width': '90%'}" ngStyle.lt-lg="{'width': '100%'}"></mat-divider>
  <p style="font-size: 14px; margin-top: 3px; margin-bottom: 9px;">
    Enter your full name and the inspection date. Please <a routerLink="/contact">contact us</a> if you have any questions.
  </p>
  <form [formGroup]="formInspectorInfo"
    [ngStyle]="{'width': '70%'}" ngStyle.lt-lg="{'width': '100%'}">
    <div fxLayout="row" fxLayout.lt-md="column wrap" fxLayoutGap="25px" fxLayoutGap.lt-md="3px">
      <div fxFlex="50%">
        <mat-form-field
          appearance="outline"
          style="min-width: 250px;">
          <mat-label>Inspector Fullname</mat-label>
          <input matInput required autocomplete="off"
            placeholder="Inspector Fullname"
            maxLength="100"
            id="ebbInspectorName"
            name="ebbInspectorName"
            formControlName="ebbInspectorName"
            [readonly]="this.submittedInspection"
            [disabled]="this.submittedInspection">
            @if (onCheckInspectionControlValidators('ebbInspectorName')) {
              <mat-error
                >
                Inspector fullname required
              </mat-error>
            }
            @if (formInspectorInfo.get('ebbInspectorName').value && formInspectorInfo.get('ebbInspectorName').value.length >= 100) {
              <mat-hint>
                Maximum 100 characters
              </mat-hint>
            }
          </mat-form-field>
        </div><div fxFlex="50%">
        <mat-form-field style="min-width: 250px;" appearance="outline" id="ebbInspectionDateField">
          <mat-label>Inspection Date</mat-label>
          <input matInput [matDatepicker]="pickerInspectionDate" required
            autocomplete="off"
            placeholder="Inspection Date"
            id="ebbInspectionDate"
            name="ebbInspectionDate"
            formControlName="ebbInspectionDate"
            [readonly]="this.submittedInspection"
            [disabled]="this.submittedInspection">
            <mat-datepicker-toggle matSuffix [for]="pickerInspectionDate"></mat-datepicker-toggle>
            <mat-datepicker #pickerInspectionDate></mat-datepicker>
            @if (onCheckInspectionControlValidators('ebbInspectionDate')) {
              <mat-error
                >
                Inspection date required
              </mat-error>
            }
          </mat-form-field>
        </div>
      </div>

      <button
        mat-raised-button color="primary"
        type="submit"
        (click)="onClickSaveInspectionInfo()"
        [disabled]="formInspectorInfo.pristine || formInspectorInfo.invalid || this.submittedInspection">
        SAVE
      </button>

      @if (formSavingProgress) {
        <div style="margin-top: 12px; margin-left: 12px;">
          <mat-progress-bar mode="indeterminate" style="width: 300px;"></mat-progress-bar>
        </div>
      }
    </form>
  </div>
